import { render, staticRenderFns } from "./BatchRemoveTeam.vue?vue&type=template&id=6cb95416"
import script from "./BatchRemoveTeam.vue?vue&type=script&lang=ts"
export * from "./BatchRemoveTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports